import { axiosNoAuthClient } from '@/shared/apis/config';
import { DtoVerificationType } from '@/shared/constants';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const sendCodeEmailFormSchema = z.object({
  key: z.string(),
  type: z.nativeEnum(DtoVerificationType),
});
export type SendCodeEmailFormType = z.infer<typeof sendCodeEmailFormSchema>;

export const sendCodeEmailApi = async (formData: SendCodeEmailFormType) => {
  try {
    const response = await axiosNoAuthClient.post(
      '/v1.0/verification/send-code/email',
      formData,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useSendCodeEmailApi = () => {
  return useMutation({
    mutationFn: sendCodeEmailApi,
  });
};
